import { Controller } from "react-hook-form";
import {
  Flex,
  Heading,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import FormInput from "../../../components/forms/form-Input";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import { CUSTOMER_TYPES, CUSTOMER_STATUS } from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import { useGetUsersList } from "services/auth-api";
import { useEffect } from "react";
import { Textarea } from "@repo/ui";

export default function CustomerInformation({
  onNextStep,
  control,
  errors,
  handleSubmit,
  isValid,
}) {
  const { data: employees, mutate: getUsersList } = useGetUsersList();
  console.log("errrors", errors);
  useEffect(() => {
    getUsersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    clientId: {
      required: "Please Enter Client Id",
      pattern: {
        value: /^[a-zA-Z0-9]+$/,
        message: "Client Id can only be Alphanumeric",
      },
      validate: (value) => {
        if (value.toString().length > 100) return "Client Id is Too Long!";

        return true;
      },
    },
    name: {
      required: "Please Enter Name",
      validate: (value) => {
        if (value.length > 100) return "Name is Too Long!";

        return true;
      },
    },
    shortName: {
      required: "Please Enter Name",
      validate: (value) => {
        if (value.length > 100) return "Short Name is Too Long!";
        if (value.length < 3) return "Short Name is Too Short!";
        return true;
      },
    },
    customerType: {
      required: "Please Select Customer Type",
    },
    status: {
      required: "Please Select Customer Status",
    },
    customerCode: {
      validate: (value) => {
        if (value.length > 50) return "Customer Code is Too Long!";
        return true;
      },
    },
  };

  return (
    <>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Customer Information</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            onClick={() => {}}
          >
            <Button isDisabled={!isValid} onClick={handleSubmit(onNextStep)}>
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Client Id"
        name="clientId"
        rules={formValidationRules.clientId}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Customer Name"
        name="name"
        rules={formValidationRules.name}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Short Name"
        name="shortName"
        info="Must Contain More Than 3 Characters"
        rules={formValidationRules.shortName}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Customer Type"
        name="customerType"
        data={CUSTOMER_TYPES || []}
        placeholder="Select Customer Type"
        rules={formValidationRules.customerType}
        dropdownProps={{ filterable: false }}
      />
      <FormInput
        {...generalFieldProps}
        label="Customer Code"
        name="customerCode"
        rules={formValidationRules.customerCode}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Status"
        name="status"
        data={CUSTOMER_STATUS || []}
        placeholder="Select Customer Status"
        dropdownProps={{ filterable: false }}
        rules={formValidationRules.status}
      />{" "}
      <FormInput
        {...generalFieldProps}
        label="Requested By"
        name="requestedBy"
      />
      <div style={{ width: "100%" }} />
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="hasSeparateDispenseCount"
          rules={formValidationRules.hasSeparateDispenseCount || {}}
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Has Separate Dispense Count
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="requiresEVhr"
          rules={formValidationRules.requiresEVhr || {}}
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>Requires EVhr</FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <div className="full-width-field">
        <FormControl>
          <FormLabel>Comments</FormLabel>
          <Controller
            control={control}
            name="comments"
            render={({ field }) => (
              <Textarea
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              />
            )}
          />
        </FormControl>
      </div>
    </>
  );
}
